import * as React from 'react';
export const DropDownArrow = 
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="16"
    viewBox="0 0 18 18"
  >
    <path d="M5 8l4 4 4-4z" />
  </svg>
;

export const customStyle = {
  control: (base, state) => ({
    ...base,
    borderTop: '0 !important',
    borderLeft: '0 !important',
    borderRight: '0 !important',
    borderRadius: '0 !important',
    borderWidth: state.isFocused ? '2px !important' : '0.5px !important',
    borderColor: state.isFocused ? ' #4e5052 !important' : '#e9edf2 !important',
    boxShadow: state.isFocused ? 'grey !important' : '0 !important',
  })
}



export const EstiloCombos = {
  control: (base, state) => ({
    ...base,
    borderTop: '1 !important',
    borderLeft: '1 !important',
    borderRight: '1 !important',
    borderRadius: '1 !important',
    borderWidth: state.isFocused ? '2px !important' : '0.5px !important',
    borderColor: state.isFocused ? ' #4e5052 !important' : '#a1abb6 !important',
    boxShadow: state.isFocused ? 'grey !important' : '0 !important',
  })
}

export const TrashBinIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-trash color-gris-megatone"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
  </svg>
);